import { Injectable, Signal, signal } from '@angular/core'
import { MenuItem } from 'primeng/api'

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private _menu = signal<MenuItem[]>([])
    private _userMenu = signal<MenuItem[]>([])

    public get(): Signal<MenuItem[]> {
        return this._menu
    }

    public getUserMenu(): Signal<MenuItem[]> {
        return this._userMenu
    }

    public set(value: MenuItem[]): void {
        this._menu.set(value)
    }

    public setUserMenu(value: MenuItem[]): void {
        this._userMenu.set(value)
    }
}
